<style lang="less">
.pop-select-store {
  .pop-select-dropdown {
    max-height: inherit;
    user-select: none;
  }
  .pop-lookup {
    min-width: 604px;
    padding-top: 10px;
    width: 100%;
    background-color: #ffffff;
    height: 36px;
    display: flex;
  }
  .pop-select-dropdown {
    width: 604px;
    padding: 0;
    white-space: nowrap;
    overflow: visible;
  }
  .left {
    position: relative;
    display: flex;
  }
  .right {
    display: flex;
    padding-left: 15px;
    height: 26px;
    line-height: 26px;
    vertical-align: middle;
    cursor: pointer;
    & i{
      line-height: 26px;
    }
  }
  .pop-search {
    width: 100%;
    height: 26px;
    border-radius: 13px;
    border: solid 1px #dbdbdb;
    background-color: #ffffff;
    color: #333333;
    font-size: 12px;
    line-height: 26px;
    padding-left: 27px;
    outline: none;
  }
  .pop-search-icon {
    left: 14px;
    top: 50%;
    margin-top: -9px;
    position: absolute;
    z-index: 1;
  }
  .business-group{
    padding-left: 10px;
    line-height: 24px;
    white-space:normal;
    h4{
      line-height: 17px;
      color:#000000;
      padding: 6px 0 0;
    }
  }
  .right span {
    font-size: 12px;
    color: #37b9f2;
    vertical-align: middle;
  }
  .left {
    width: calc(~"100% - 247px");
    padding-left: 5px;
  }

  .filter {
    padding-left: 10px;
  }
  .filter h4 {
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    line-height: 1;
    display: block;
    padding: 8px 0 6px 0;
  }
  .filter h5 {
    font-size: 12px;
    font-weight: bold;
    font-style: normal;
    line-height: 1;
    display: block;
    padding: 8px 0 6px 0;
  }
  .filter h5 span {
    color: #999;
  }

  hr.line {
    border: none;
    border-top: 1px dashed #c9c9c9;
    width: calc(~"100% - 10px");
    margin-left: 5px;
    margin-top: 6px;
    height: 0px;
    font-size: 0;
  }
  .pannel {
    height: 177px;
     display: flex;
  }
  .pannel .tab,
  .pannel .record {
    // float: left;
    display: flex;
  }
  .pannel .tab {
    width: 130px;
    background-color: #fbfbfb;
    overflow-y: auto;
    overflow-x: hidden;
  }
  .pannel .tab ul {
    list-style: none;
    width: 100%;
    padding-left: 0px !important;
  }
  .pannel .tab li {
    display: block;
    padding-left: 10px;
    padding-top: 8px;
    height: 32px;
    margin-bottom: 0px !important;
    font-size: 12px;
    cursor: pointer;
  }
  .pannel .tab li.cur {
    background-color: #ffffff;
  }
  .pannel .pop-checkbox-wrapper {
    margin-right: 5px;
  }
  .pannel .record ul {
    list-style: none;
    overflow: hidden;
    display: flex;
    flex-wrap:wrap;
    padding-left: 0 !important;
  }
  .pannel .record ul li {
    height: 18px;
    display: flex;
    width: 50%;
    margin-bottom: 15px;
    padding-left: 10px;
  }
  .pannel .record ul li:nth-child(-n+2) {
    margin-top: 15px;
  }
  .pannel .content {
    width: calc(~"100% - 8px");
    overflow-y: auto;
    overflow-x: hidden;
  }
  .pannel .record {
    // padding-top: 15px;
    width: calc(~"100% - 130px");
  }
  .pannel .content::-webkit-scrollbar,
  .pannel .tab::-webkit-scrollbar {
    width: 4px;
  }
  /*滚动条滑块*/
  .pannel .content::-webkit-scrollbar-thumb,
  .pannel .tab::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.3);
  }
  /*滚动条轨道*/
  .pannel .content::-webkit-scrollbar-track,
  .pannel .tab::-webkit-scrollbar-track {
    /* background-color: #fff; */
    border-radius: 4px;
    padding-right: 3px;
  }
  .pop-select-dropdown .myTab .pop-tabs-ink-bar {
    left: auto;
  }

  .pop-select-dropdown .myTab .pop-tabs-nav {
    padding-left: 10px;
  }
  .pop-select-dropdown .group{
    display: flex;
  }
  .pop-select-dropdown .group .group-right{
    padding-left: 50px;
  }



}
</style>


<template>
  <div :class="classes" v-el:lookup v-clickoutside="handleClose">
    <div :class="[`${prefixCls}-selection`]" v-el:reference @click="toggleMenu">
      <div :class="[`${PRE}-tag`]" v-for="(index,item) in filtered_selectedMultiple">
        <span :class="[`${PRE}-tag-text`]">{{ item.name }}</span>
        <p-icon type="ios-close-empty" @click.stop="removeTag(index,item.id)"></p-icon>
      </div>
      <span :class="[`${prefixCls}-placeholder`]" v-show="showPlaceholder">{{ localePlaceholder }}</span>
      <!-- <span
        :class="[`${prefixCls}-selected-value`]"
        v-show="!showPlaceholder"
      >{{ selectedSingle }}</span>-->
      <p-icon
        type="ios-close"
        :class="[`${prefixCls}-arrow`]"
        v-show="showCloseIcon"
        @click.stop="clearSingleSelect"
      ></p-icon>
      <p-icon type="ios-arrow-down" :class="[`${prefixCls}-arrow`]" v-if="!remote"></p-icon>
    </div>
    <Drop v-show="dropVisible" :placement="placement" transition="slide-up" v-ref:dropdown>
      <div :class="[`${PRE}-lookup`]">
        <div class="left">
          <p-icon type="ios-search" :size="18" color="#dbdbdb" :class="[`${PRE}-search-icon`]"></p-icon>
          <input type="text" v-model="searchWord" :class="[`${PRE}-search`]" />
        </div>
        <div class="right" @click="advancedQuery=!advancedQuery">
          <p-icon type="funnel"></p-icon>
          <span>高级筛选</span>
        </div>
      </div>
      <div class="business-group" v-if="retailing">
          <h4>业态</h4>
          <p-checkbox-group v-if="across" :model.sync="curBusinessModelList">
            <p-checkbox
              :value="it.id"
              v-for="(index,it) in businessModelList"
              :key="index"
            >{{it.name}}</p-checkbox>
          </p-checkbox-group>
          <p-radio-group v-else :model.sync="curBusinessModel" v-ref:radio>
            <p-radio
              :value="it.id"
              v-for="(index,it) in businessModelList"
              :key="index"
            >{{it.name}}</p-radio>
          </p-radio-group>
      </div>
      <template v-if="advancedQuery">
        <div class="filter">
          <h4>类型</h4>
          <div>
            <p-checkbox-group :model.sync="type" @on-change="changeFilter">
              <p-checkbox :key="it.id" :value="it.id*1" v-for="it in freshShopTypeList">{{it.name}}</p-checkbox>
            </p-checkbox-group>
          </div>
          <div class="group">
            <div>
              <h5>
                状态
                <!-- <span>默认不显示以下状态</span> -->
              </h5>
              <div>
                <p-checkbox :checked.sync="isTest" @on-change="changeFilter">测试门店</p-checkbox>
                <p-checkbox :checked.sync="isVirtual" @on-change="changeFilter">虚拟门店</p-checkbox>
                <!-- <p-checkbox :checked.sync="freeBuy" @on-change="changeFilter">自由购</p-checkbox> -->
              </div>
            </div>
            <div class="group-right" v-if="statusList.length">
              <h5>
                运营状态
                <!-- <span>默认不显示关闭的</span> -->
              </h5>
              <div>
                <p-checkbox-group :model.sync="operationState" @on-change="changeFilter">
                  <p-checkbox :key="it.id" :value="it.id*1" v-for="it in statusList">{{it.name}}</p-checkbox>
                </p-checkbox-group>
                <!-- <p-checkbox :checked.sync="freeBuy" @on-change="changeFilter">自由购</p-checkbox> -->
              </div>
            </div>
          </div>
        </div>
      </template>
        <hr class="line" v-if="across||retailing||advancedQuery" />

      <div class="pannel">
        <div class="tab">
          <ul>
            <li
              :class="{cur:group.code==code}"
              v-for="(i,group) in getGroups()"
              :key="i"
              @click="setIndex(group.code)"
            >
              <p-checkbox
                :indeterminate="group.indeterminate"
                :checked="group.checkAll"
                @click.prevent="handleCheckAll(group)"
              >
                <span></span>
              </p-checkbox>
              {{group.name}}
              <template v-if="group.checkedCount">({{group.checkedCount}})</template>
            </li>
          </ul>
        </div>
        <div class="record">
          <div class="content">
            <p-checkbox-group :model.sync="model">
              <ul>
                <li :title="store.id" v-for="(index,store) in groupStores" :key="index">
                  <p-checkbox :value="store.id">{{store.name}}</p-checkbox>
                </li>
              </ul>
            </p-checkbox-group>
          </div>
        </div>
      </div>
    </Drop>
    <div
      :class="[`${formPrefixCls}-error-msg-tip`]"
      v-if="validateMessage && showMessage"
    >{{ validateMessage }}</div>
    <!-- {{baseData|json}} -->
  </div>
</template>
<script>
import { oneOf, PRE } from "../../common/utils/assist";
import Drop from "./dropdown.vue";
import directives from "../../common/directives/directives";
import { getJSON } from "../common/utils";
import Emitter from "../../common/mixins/emitter";
import AsyncValidator from "async-validator";
const prefixCls = `${PRE}-select`;
const formPrefixCls = `${PRE}-form-item`;
export default {
  name: "StoreCheck",
  mixins: [Emitter],
  components: { Drop },
  directives: { clickoutside: directives.clickoutside },
  ready() {
    let { dataType, useTypeList } = this;
    this.getData(dataType, useTypeList);
  },
  props: {
    model: {
      type: [Array, String],
      default() {
        return [];
      }
    },
    multiple: {
      type: Boolean,
      default: true
    },
    authType: {
      type: String,
      default: "1"
    },
    across: {
      type: Boolean,
      default: false
    },
    clearable: {
      type: Boolean,
      default: true
    },
    debug: {
      type: Boolean,
      default: false
    },
    retailing: {
      type: Boolean,
      default: false
    },
    dataType: {
      type: String,
      default: ""
    },
    useTypeList: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String
    },
    size: {
      validator(value) {
        return oneOf(value, ["small", "large", "default"]);
      }
    },
    validateMessage: null,
    showMessage: {
      type: Boolean,
      default: true
    },
    rules: {
      type: Array,
      default() {
        return [];
      }
    },
    placement: {
      validator(value) {
        return oneOf(value, [
          "top",
          "top-start",
          "top-end",
          "bottom",
          "bottom-start",
          "bottom-end"
        ]);
      },
      default: "bottom"
    }
  },
  data() {
    return {
      statusList: [],
      curBusinessModel:"",
      curBusinessModelList:[],
      businessModelList: [],
      freshShopTypeList: [],
      advancedQuery: false,
      type: [],
      operationState: [],
      isTest: false,
      isVirtual: false,
      freeBuy: true,
      searchWord: "",
      baseData: [],
      groups: [],
      stores: [],
      code: "86",
      PRE: PRE,
      prefixCls: prefixCls,
      formPrefixCls: formPrefixCls,
      visible: false,
      selectedMultiple: [],
      validateState: ""
    };
  },
  computed: {
    showCloseIcon() {
      return this.clearable && this.selectedMultiple.length;
    },
    groupStores() {
      return this.getStoresByCode(this.code);
    },
    filtered_selectedMultiple() {
      return this.selectedMultiple;
    },
    classes() {
      return [
        `${prefixCls}`,
        `${prefixCls}-store`,
        {
          [`${PRE}-form-item-error`]: this.validateState == "error",
          [`${prefixCls}-visible`]: this.visible,
          [`${prefixCls}-disabled`]: this.disabled,
          [`${prefixCls}-multiple`]: this.multiple,
          [`${prefixCls}-single`]: !this.multiple,
          [`${prefixCls}-show-clear`]: this.showCloseIcon,
          [`${prefixCls}-${this.size}`]: !!this.size
        }
      ];
    },
    showPlaceholder() {
      let status = false;
      if (Array.isArray(this.filtered_selectedMultiple)) {
        if (!this.filtered_selectedMultiple.length) {
          status = true;
        }
      }
      return status;
    },
    inputStyle() {
      let style = {};
      if (this.multiple) {
        if (this.showPlaceholder) {
          style.width = "100%";
        } else {
          style.width = `${this.inputLength}px`;
        }
      }
      return style;
    },
    localePlaceholder() {
      if (this.placeholder === undefined) {
        return "";
      } else {
        return this.placeholder;
      }
    },
    transitionName() {
      return this.placement === "bottom" ? "slide-up" : "slide-down";
    },
    dropVisible() {
      let status = true;
      return this.visible && status;
    }
  },
  methods: {
    getData(dataType, useTypeList) {
      let d = getJSON(
        this.debug
          ? "/assets/store.json"
          : `//shop.7fresh.com/shop/component/rest/index?dataType=${dataType}&useTypeList=${useTypeList}&authType=${this.authType}`,
        "GET"
      );
      d.done(data => {
        this.initData(data);
      });
    },
    tabChange(value) {
      if(!this.across&&this.retailing){
        let store = this.getStoreById(
          this.model && this.model.length ? this.model[0] : ""
        );
        if (store) {
          if (store.businessModelModel.modelKey != value) {
            this.selectedMultiple = [];
            this.model = [];
          }
        }
      }else{
        let recycle=[];
        for(let id of this.model){
          let store = this.getStoreById(id);
          if (store) {
            if (value.length&&!value.includes(store.businessModelModel.modelKey)) {
              recycle.push(id);
            }
          }
        }
        for(let id of recycle){
          this.model.splice(
            this.model.findIndex(sid => sid == id),
            1
          );
        }      
        recycle.length&&this.setSelectedTags();
        // this.selectedMultiple = [];
        // this.model = [];
      }
    },
    initData(data) {
      let {
        code,
        name,
        regions,
        businessModelList,
        freshShopTypeList,
        statusList = []
      } = data;
      this.type = freshShopTypeList.map(item => item.id * 1);
      let statusListTmp = statusList.filter(item => item.id != 3);
      this.operationState = statusListTmp.map(item => item.id * 1);
      let groups = [];
      let stores = [];
      groups.push({
        indeterminate: false,
        checkAll: false,
        name,
        checkedCount: 0,
        code
      });
      for (let region of regions) {
        let { name, code, shops } = region;
        groups.push({
          name,
          code,
          checkAll: false,
          indeterminate: false,
          checkedCount: 0
        });
        for (let shop of shops) {
          shop.fatherCode = code;
          stores.push(shop);
        }
      }
      this.groups = groups;
      this.stores = stores;
      let isTest = window.localStorage.getItem("isTest");
      let isVirtual = window.localStorage.getItem("isVirtual");
      let freeBuy = window.localStorage.getItem("freeBuy");
      let type = window.localStorage.getItem("type");
      let operationState = window.localStorage.getItem("operationState");
      this.type = type ? JSON.parse(type) : this.type;
      this.operationState = operationState
        ? JSON.parse(operationState)
        : this.operationState;

      this.isTest = JSON.parse(isTest ? isTest : true);
      this.isVirtual = JSON.parse(isVirtual ? isVirtual : true);
      this.businessModelList = businessModelList || [];
      this.statusList = statusList || [];
      this.freshShopTypeList = freshShopTypeList || [];
      this.initCurBusinessModel();
      // this.curBusinessModel =this.across&&this.retailing?businessModelList.length
      //   ? businessModelList.map(businessModel=>businessModel.id)
      //   : []:'';
      // this.freeBuy=JSON.parse(freeBuy?freeBuy:false);
      this.onChange();
    },
    initCurBusinessModel(){
      if(this.retailing){
        if(this.across){
          this.curBusinessModelList=this.businessModelList.map(businessModel=>businessModel.id)
        }else{
          this.curBusinessModel=this.businessModelList[0].id
        }
      }else{
        this.curBusinessModelList=[];
      }
    },
    updateTabBar() {
      // this.$nextTick(function() {
      //   this.$emit("on-data-loaded", this);
      // });
      this.$nextTick(() => {
        this.$refs.radio && this.$refs.radio.updateModel();
      });
    },
    changeFilter() {
      window.localStorage.setItem(
        "operationState",
        JSON.stringify(this.operationState)
      );
      window.localStorage.setItem("type", JSON.stringify(this.type));
      window.localStorage.setItem("isTest", JSON.stringify(this.isTest));
      window.localStorage.setItem("isVirtual", JSON.stringify(this.isVirtual));
      window.localStorage.setItem("freeBuy", JSON.stringify(this.freeBuy));
      let deleteIds = [];
      for (let id of this.model) {
        !this.judgement(this.stores.find(store => store.id == id))
          ? deleteIds.push(id)
          : null;
      }
      for (let id of deleteIds) {
        this.model.splice(
          this.model.findIndex(sid => sid == id),
          1
        );
      }
      //this.onChange(this.model);
    },
    judgement(store) {
      let isTest = store.test
        ? store.test && this.isTest
          ? true
          : false
        : true;
      let isVirtual = store.virtual
        ? store.virtual && this.isVirtual
          ? true
          : false
        : true;
      let isFreeBuy = store.freeBuy
        ? store.freeBuy && this.freeBuy
          ? true
          : false
        : true;
      let isInOperationState = this.operationState.includes(store.status)
        ? true
        : false;
      let isInType = this.type.includes(store.type) ? true : false;
      let isBusinessModel=false;
      if(this.retailing){
        if(this.across){
          if(store.businessModelModel.modelKey){
            isBusinessModel=this.curBusinessModelList.includes(store.businessModelModel.modelKey)  
          }
        }else{
          isBusinessModel=this.curBusinessModel==store.businessModelModel.modelKey
        }
      }else{
        isBusinessModel=true;
      }

      // let isBusinessModel = this.retailing
      //   ? store.businessModelModel.modelKey &&
      //     this.curBusinessModel.includes(store.businessModelModel.modelKey)
      //   : true;
      return (
        isBusinessModel &&
        isTest &&
        isVirtual &&
        isFreeBuy &&
        isInType &&
        isInOperationState
      );
    },
    getStoresByCode(code) {
      const parsedQuery = this.searchWord.replace(
        /(\^|\(|\)|\[|\]|\$|\*|\+|\.|\?|\\|\{|\}|\|)/g,
        "\\$1"
      );
      return this.stores.filter(store => {
        let isMatchingText = new RegExp(parsedQuery, "i").test(
          !isNaN(this.searchWord * 1) ? store.id : store.name
        );
        if (code == "86") {
          return this.judgement(store) && isMatchingText;
        } else {
          if (store.fatherCode == code) {
            return this.judgement(store) && isMatchingText;
          }
        }
        return false;
      });
    },
    handleCheckAll(group) {
      this.setIndex(group.code);
      group.checkAll = !group.checkAll;
      let subShopIds = this.getStoresByCode(group.code).map(store => store.id);
      if (group.checkAll) {
        let { model: ary } = this;
        ary = [...new Set([...ary, ...subShopIds])];
        this.model = ary;
      } else {
        for (let id of subShopIds) {
          this.model.splice(
            this.model.findIndex(sid => sid == id),
            1
          );
        }
      }
      //this.onChange(this.model);
    },
    getStoreById(id) {
      return this.stores.find(store => store.id == id);
    },
    setSelectedTags() {
      this.selectedMultiple = [];
      let w = 0;
      for (let sid of this.model) {
        let { id = "", name = "" } = this.getStoreById(sid) || {};
        if (id && name) {
          this.selectedMultiple.push({
            id,
            name
          });
        }
      }

      this.$nextTick(() => {
        const nodeList = this.$els.lookup.querySelectorAll(".pop-tag");
        const arrayList = Array.from(nodeList);
        w = arrayList.length
          ? arrayList.reduce((a, b) => {
              return (a.offsetWidth ? (a.offsetWidth+4) : a) + (b.offsetWidth+4);
            })
          : 0;
        if (w > this.$els.lookup.offsetWidth - 32) {
          this.selectedMultiple = [
            {
              id: -1,
              name: `已选择${this.selectedMultiple.length}个门店`
            }
          ];
        }
      });
    },
    onChange(ids) {
      if (this.model.length&&this.retailing&&!this.across) {
        let store = this.getStoreById(this.model[0]);
        if (store) {
          this.curBusinessModel = store.businessModelModel.modelKey;
          this.updateTabBar();
        }
      }
      for (let group of this.groups) {
        // this.handleCheckAll(group);
        let subShopIds = this.getStoresByCode(group.code).map(
          store => store.id
        );
        let arrayTmp = [];
        arrayTmp = this.model.filter(sid => {
          return subShopIds.includes(sid);
        });
        group.checkedCount = arrayTmp.length;
        group.indeterminate =
          arrayTmp.length == 0 || arrayTmp.length == subShopIds.length
            ? false
            : true;
        group.checkAll =
          arrayTmp.length == subShopIds.length && arrayTmp.length
            ? true
            : false;
      }
      if (this.stores.length) this.setSelectedTags();

      if (ids) {
        let objList = ids.map(id => {
          return this.stores.find(store => store.id == id);
        });
        this.validateFn();
        this.$emit("on-change", ids, objList);
      }
    },
    getGroups() {
      return this.groups.filter(
        group => this.getStoresByCode(group.code).length
      );
    },
    setIndex(code) {
      this.code = code;
    },
    toggleMenu() {
      if (this.disabled) {
        return false;
      }
      this.visible = !this.visible;
      this.broadcast("Drop", "on-update-popper");
    },
    hideMenu() {
      this.visible = false;
      this.broadcast("Drop", "on-destroy-popper");
    },
    // find option component
    clearSingleSelect() {
      if (this.showCloseIcon) {
        this.selectedMultiple = [];
        this.model = [];
        //this.onChange(this.model);
      }
    },
    removeTag(index, id) {
      if (this.disabled) {
        return false;
      }
      if (id == -1) {
        this.selectedMultiple = [];
        this.model = [];
        //this.onChange(this.model);
      } else {
        this.selectedMultiple.splice(index, 1);
        this.model.splice(
          this.model.findIndex(sid => sid == id),
          1
        );
        //this.onChange(this.model);
      }
      // this.broadcast('Drop', 'on-update-popper');
    },
    // to select option for single
    validateFn(callback) {
      if (this.rules.length) {
        var validator = new AsyncValidator({
          Store: this.rules
        });
        var tmp = this.model;
        validator.validate({ Store: tmp }, { firstFields: true }, errors => {
          this.validateMessage = errors ? errors[0].message : "";
          this.validateState = !errors ? "success" : "error";
          callback ? callback(this.validateMessage) : null;
        });
      } else {
        this.validateMessage = "";
        this.validateState = "";
      }
    },
    handleClose() {
      this.hideMenu();
    },
    handleKeydown(e) {
      if (this.visible) {
        const keyCode = e.keyCode;
        // Esc slide-up
        if (keyCode === 27) {
          e.preventDefault();
          this.hideMenu();
        }
      }
    }
    // use when slot changed
  },
  compiled() {
    document.addEventListener("keydown", this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener("keydown", this.handleKeydown);
  },
  watch: {
    searchWord() {
      this.changeFilter();
    },
    model(pre,next) {
      this.onChange(next);
    },
    retailing(value) {
      this.model = [];
    },
    across(value) {
      this.initCurBusinessModel();
    },
    dataType(value) {
      this.model = [];
      this.getData(value, this.useTypeList);
      window.localStorage.removeItem("type");
    },
    useTypeList(value) {
      this.model = [];
      this.getData(this.dataType, value);
      window.localStorage.removeItem("type");
    },
    curBusinessModel(value) {
      this.tabChange(value);
    },
    curBusinessModelList(value) {
      this.tabChange(value);
    }
  },
  events: {
    "on-form-reset"(field) {
      if (field) {
        this.validateMessage = "";
        this.validateState = "";
      }
      return false;
    }
  }
};
</script>



// WEBPACK FOOTER //
// store-check.vue?57a356ca